var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.loadings)?_c('div',{staticClass:"pageCovers"},[_c('van-loading',{staticStyle:{"margin-top":"40vh"},attrs:{"size":"50","color":"white","vertical":""}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }